import React from 'react';
import Chatbot from './components/Chatbot';
import './styles/chatbot.css';

function App() {
	return (
		<div className="App">
			{/* The floating chatbot component */}
			<Chatbot />
		</div>
	);
}

export default App;
